module.exports = __webpack_public_path__ + "img/BHR.8f3af403.svg";